import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import ptBR from "./locales/pt-br/translation.json"
import ptPT from "./locales/pt-pt/translation.json"

const isGeaBrasil = import.meta.env.VITE_THEME === "geabrasil"

i18n.use(initReactI18next).init({
  resources: {
    "pt-PT": {
      translation: ptPT,
    },
    "pt-BR": { translation: ptBR },
  },
  lng: isGeaBrasil ? "pt-BR" : "pt-PT",
  fallbackLng: "pt-PT",
  load: "currentOnly",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
})

export default i18n
